import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';
export default class MessageForm extends Component {
  render() {
    const { onConfirm, MessageText, isLoading } = this.props;
    return (
      <div>
        <label className="message_text">
          <div>{MessageText}</div>
        </label>
        <hr className="message_hr_line"/>
          <div className="form-group">
            <div className="col-sm-12 message__btngrounp">
              {
                this.props.onCancel &&
                <button onClick={this.props.onCancel} className="btn btn-default pull-right message__btnGrounp-btn" disabled={isLoading}>
                  取消
                </button>
              }
              <button onClick={onConfirm} className="btn btn-default pull-right message__btnGrounp-btn" disabled={isLoading}>
                {
                  isLoading ? <i className="fa fa-spinner fa-pulse"></i> : this.props.onConfirmName || '確定'
                }
              </button>
            </div>
          </div>
      </div>
    );
  }
}
MessageForm.propTypes = {
  onConfirmName: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  MessageText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  isLoading: PropTypes.bool,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/components/MessageForm/index.js
 **/